// extracted by mini-css-extract-plugin
export default {"breakpoint_tablet_max_width_1199":"1199px","no_pf_result":"fas_no_pf_result","headline":"fas_headline","button":"fas_button","arrow":"fas_arrow"};